/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const Root = styled(Box)(() => ({
  position: 'relative',

  '.MuiTypography-root': {
    width: '32px',
    height: '32px',
    position: 'relative',
    zIndex: 1,
  },

  '&:hover .MuiBox-root': {
    opacity: 0.4,
  },
}));

interface ButtonBgProps {
  customColor: string;
}

export const ButtonBg = styled(Box, {
  shouldForwardProp: prop => prop !== 'customColor',
})<ButtonBgProps>(({customColor}) => ({
  width: '32px',
  height: '32px',
  borderRadius: '8px',
  background: customColor,
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 0,
  transition: '0.2s',
  opacity: 0.2,
}));
